/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BrandPreferenceOption_BrandFragment = { __typename: 'PimBrandRef', id: string, title: string };

export type BrandPreferenceOptionsAvailableFiltersQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.PimSearchProductsFilters>;
}>;


export type BrandPreferenceOptionsAvailableFiltersQuery = { pimSearchProductsAvailableFilters: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchProductsAvailableFiltersResult', brands: Array<{ __typename: 'PimAvailableFilterBrand', key: string }>, brandLines: Array<{ __typename: 'PimAvailableFilterBrandLine', key: string }> } };

export type BrandPreferenceOptionsBrandsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  filter?: Types.InputMaybe<Types.PimSearchBrandFilter>;
}>;


export type BrandPreferenceOptionsBrandsQuery = { pimSearchBrands: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchBrandsResult', totalCount: number, brands: Array<{ __typename: 'PimBrandRef', id: string, title: string }> } };

export const BrandPreferenceOption_BrandFragmentDoc = gql`
    fragment BrandPreferenceOption_Brand on PimBrandRef {
  id
  title
}
    `;
export const BrandPreferenceOptionsAvailableFiltersDocument = gql`
    query BrandPreferenceOptionsAvailableFilters($filters: PimSearchProductsFilters) {
  pimSearchProductsAvailableFilters(filters: $filters, failOnPimError: true) {
    ... on PimSearchProductsAvailableFiltersResult {
      brands {
        key
      }
      brandLines {
        key
      }
    }
  }
}
    `;

/**
 * __useBrandPreferenceOptionsAvailableFiltersQuery__
 *
 * To run a query within a React component, call `useBrandPreferenceOptionsAvailableFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandPreferenceOptionsAvailableFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandPreferenceOptionsAvailableFiltersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBrandPreferenceOptionsAvailableFiltersQuery(baseOptions?: Apollo.QueryHookOptions<BrandPreferenceOptionsAvailableFiltersQuery, BrandPreferenceOptionsAvailableFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandPreferenceOptionsAvailableFiltersQuery, BrandPreferenceOptionsAvailableFiltersQueryVariables>(BrandPreferenceOptionsAvailableFiltersDocument, options);
      }
export function useBrandPreferenceOptionsAvailableFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandPreferenceOptionsAvailableFiltersQuery, BrandPreferenceOptionsAvailableFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandPreferenceOptionsAvailableFiltersQuery, BrandPreferenceOptionsAvailableFiltersQueryVariables>(BrandPreferenceOptionsAvailableFiltersDocument, options);
        }
export function useBrandPreferenceOptionsAvailableFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandPreferenceOptionsAvailableFiltersQuery, BrandPreferenceOptionsAvailableFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandPreferenceOptionsAvailableFiltersQuery, BrandPreferenceOptionsAvailableFiltersQueryVariables>(BrandPreferenceOptionsAvailableFiltersDocument, options);
        }
export type BrandPreferenceOptionsAvailableFiltersQueryHookResult = ReturnType<typeof useBrandPreferenceOptionsAvailableFiltersQuery>;
export type BrandPreferenceOptionsAvailableFiltersLazyQueryHookResult = ReturnType<typeof useBrandPreferenceOptionsAvailableFiltersLazyQuery>;
export type BrandPreferenceOptionsAvailableFiltersSuspenseQueryHookResult = ReturnType<typeof useBrandPreferenceOptionsAvailableFiltersSuspenseQuery>;
export type BrandPreferenceOptionsAvailableFiltersQueryResult = Apollo.QueryResult<BrandPreferenceOptionsAvailableFiltersQuery, BrandPreferenceOptionsAvailableFiltersQueryVariables>;
export const BrandPreferenceOptionsBrandsDocument = gql`
    query BrandPreferenceOptionsBrands($limit: Int!, $offset: Int!, $filter: PimSearchBrandFilter) {
  pimSearchBrands(limit: $limit, offset: $offset, filter: $filter) {
    ... on PimSearchBrandsResult {
      brands {
        id
        ...BrandPreferenceOption_Brand
      }
      totalCount
    }
  }
}
    ${BrandPreferenceOption_BrandFragmentDoc}`;

/**
 * __useBrandPreferenceOptionsBrandsQuery__
 *
 * To run a query within a React component, call `useBrandPreferenceOptionsBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandPreferenceOptionsBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandPreferenceOptionsBrandsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBrandPreferenceOptionsBrandsQuery(baseOptions: Apollo.QueryHookOptions<BrandPreferenceOptionsBrandsQuery, BrandPreferenceOptionsBrandsQueryVariables> & ({ variables: BrandPreferenceOptionsBrandsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandPreferenceOptionsBrandsQuery, BrandPreferenceOptionsBrandsQueryVariables>(BrandPreferenceOptionsBrandsDocument, options);
      }
export function useBrandPreferenceOptionsBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandPreferenceOptionsBrandsQuery, BrandPreferenceOptionsBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandPreferenceOptionsBrandsQuery, BrandPreferenceOptionsBrandsQueryVariables>(BrandPreferenceOptionsBrandsDocument, options);
        }
export function useBrandPreferenceOptionsBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandPreferenceOptionsBrandsQuery, BrandPreferenceOptionsBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandPreferenceOptionsBrandsQuery, BrandPreferenceOptionsBrandsQueryVariables>(BrandPreferenceOptionsBrandsDocument, options);
        }
export type BrandPreferenceOptionsBrandsQueryHookResult = ReturnType<typeof useBrandPreferenceOptionsBrandsQuery>;
export type BrandPreferenceOptionsBrandsLazyQueryHookResult = ReturnType<typeof useBrandPreferenceOptionsBrandsLazyQuery>;
export type BrandPreferenceOptionsBrandsSuspenseQueryHookResult = ReturnType<typeof useBrandPreferenceOptionsBrandsSuspenseQuery>;
export type BrandPreferenceOptionsBrandsQueryResult = Apollo.QueryResult<BrandPreferenceOptionsBrandsQuery, BrandPreferenceOptionsBrandsQueryVariables>;